export default "__VITE_ASSET__CtAwl65n__$_?url__"